import React from 'react'
import DayPicker from 'react-day-picker'
import moment from 'moment'
import 'react-day-picker/lib/style.css'
import {Popover} from 'common/styleguide/Popover'
import {readDateFormatFromPreferences, readFirstDayOfWeekFromPreferences} from 'lib/dateUtils'
import _ from 'lodash'
import styles from './DatePickerInput.scss'
import cx from 'classnames'

export class DatePickerInput extends React.PureComponent {
  static defaultProps = {
    dateFormat: readDateFormatFromPreferences(),
    firstDayOfWeek: readFirstDayOfWeekFromPreferences()
  }

  constructor (props) {
    super(props)
    this.state = {
      showPicker: false,
      month: this.props.date || new Date()
    }
    this._debounceClick = false
  }

  formatDate (date) {
    if (!date && this.props.allowBlank) {
      return ''
    }
    const m = moment(date)
    if (this.props.dateFormat) {
      return m.format(this.props.dateFormat)
    } else {
      const includeYear = m.year() !== moment().year()
      const format = [
        'MMMM Do',
        includeYear && 'YYYY'
      ].filter(f => f).join(', ')

      return m.format(format)
    }
  }

  showPicker = (e) => {
    const {showPicker} = this.state
    if (!showPicker) {
      this._debounceClick = true
      setTimeout(() => { this._debounceClick = false }, 500)
      this.setState({showPicker: true})
    }
  }

  onRequestClose = () => {
    if (this._debounceClick) { return }
    this.setState({showPicker: false})
  }

  onDayClick = (date) => {
    const {onDateChange} = this.props
    this.setState({showPicker: false})
    onDateChange(date)
  }

  onKeyDown = (e) => {
    const TAB_KEYCODE = 9
    if (e.keyCode === TAB_KEYCODE) {
      this.setState({showPicker: false})
    }
  }

  handleYearMonthChange = (month) => {
    this.setState({month})
  }

  render () {
    const {date, container, id, firstDayOfWeek} = this.props
    const {showPicker, month} = this.state
    return (
      <div>
        <input
          readOnly
          id={id}
          ref={r => { this._input = r }}
          value={this.formatDate(date)}
          onFocus={this.showPicker}
          onKeyDown={this.onKeyDown} />
        {showPicker && <Popover
          target={this._input}
          container={container || window.body}
          placement='bottom'
          onRequestClose={this.onRequestClose}>
          <DayPicker
            month={month}
            selectedDays={date}
            firstDayOfWeek={firstDayOfWeek}
            onDayClick={this.onDayClick}
            captionElement={({ date, localeUtils }) => (
              <YearMonthForm
                date={date}
                localeUtils={localeUtils}
                onChange={this.handleYearMonthChange}
              />
            )} />
        </Popover>}
      </div>
    )
  }
}

export const YearMonthForm = ({ date, localeUtils, onChange }) => {
  const months = localeUtils.getMonths()
  const currentYear = new Date().getFullYear()
  const years = _.range(currentYear - 10, currentYear + 5)

  const handleChange = (e) => {
    const { year, month } = e.target.form
    onChange(new Date(year.value, month.value))
  }

  return (
    <form className={cx('DayPicker-Caption', styles.captionForm)}>
      <select name='month' onChange={handleChange} value={date.getMonth()}>
        {months.map((month, i) => (
          <option key={month} value={i}>
            {month}
          </option>
        ))}
      </select>
      <select name='year' onChange={handleChange} value={date.getFullYear()}>
        {years.map(year => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </form>
  )
}
